module.exports = __webpack_public_path__ + "static/media/GooglePlay.e7b9ac64.png";